document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('.product-main-collapsable').forEach(function (detail) {

    function updateAccordainCollapsableIcons() {
      const plus = detail.querySelector('.plus-icon');
      const minus = detail.querySelector('.minus-icon');

      if (detail.hasAttribute('open')) {
        plus.style.display = "none";
        minus.style.display = "inline-block";
      } else {
        plus.style.display = "inline-block";
        minus.style.display = "none";
      }
    }

    // Run on load
    updateAccordainCollapsableIcons();

    // Update on open/close
    detail.addEventListener('toggle', updateAccordainCollapsableIcons);

  });
});
;

document.addEventListener("DOMContentLoaded", function () {

  document.querySelectorAll('.faq-section-page .faq-item').forEach(function (faqItem) {

    function updateFaqPageIcons() {
      const plus = faqItem.querySelector('.faq-section-page .faq-plus');
      const minus = faqItem.querySelector('.faq-section-page .faq-minus');

      if (faqItem.hasAttribute('open')) {
        plus.style.display = "none";
        minus.style.display = "inline-block";
      } else {
        plus.style.display = "inline-block";
        minus.style.display = "none";
      }
    }

    // Run initially
    updateFaqPageIcons();

    // Update on open/close
    faqItem.addEventListener("toggle", updateFaqPageIcons);
  });

});


document.querySelectorAll('.home-accordion summary').forEach(summary => {
  summary.addEventListener('click', function (e) {
    // STOP previous JS & native toggle
    e.preventDefault();
    e.stopImmediatePropagation();
    
    const currentDetails = this.closest('details');

    // Close all other accordions
    document.querySelectorAll('.home-accordion details').forEach(details => {
      const summaryEl = details.querySelector('summary');

      if (details !== currentDetails) {
        details.removeAttribute('open');
        summaryEl.setAttribute('aria-expanded', 'false');
      }
    });

    // Toggle current accordion
    const isOpen = currentDetails.hasAttribute('open');

    if (isOpen) {
      currentDetails.removeAttribute('open');
      this.setAttribute('aria-expanded', 'false');
    } else {
      currentDetails.setAttribute('open', '');
      this.setAttribute('aria-expanded', 'true');
    }
  }, true); // CAPTURE PHASE to override other listeners
});


// proudct page thumbnail slider drag scroll 

document.addEventListener("DOMContentLoaded", function () {
  const slider = document.querySelector('.thumbnail-list.slider');
  let isDown = false;
  let startX;
  let scrollLeft;

  slider.addEventListener('mousedown', (e) => {
    isDown = true;
    // slider.classList.add('active');
    startX = e.pageX - slider.offsetLeft;
    scrollLeft = slider.scrollLeft;
  });

  slider.addEventListener('mouseleave', () => isDown = false);
  slider.addEventListener('mouseup', () => isDown = false);

  // 🔴 IMPORTANT FIX
  document.addEventListener('mouseup', () => {
    isDown = false;
  });

  slider.addEventListener('mousemove', (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - slider.offsetLeft;
    const walk = (x - startX) * 2;
    slider.scrollLeft = scrollLeft - walk;
  });
});

